import { useEffect, useState } from "react";

const useDebounceSearch = (value, delay) => {
  const [debounceValue, setDebounceValue] = useState("");

  useEffect(() => {
    let timer;

    timer = setTimeout(() => {
      setDebounceValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debounceValue;
};

export default useDebounceSearch;
